// src/mocks/sponsoredBanner.mock.js

const sponsoredBannerMockResponse = {
  success: true,
  message: "Mock sponsored banner response",
  data: [
    {
      id: "adv-001",
      title: "Hunian Modern Colonial",
      subtitle:
        "Hunian eksklusif dengan lokasi strategis, desain modern, dan akses yang nyaman untuk keluarga.",
      bannerImage:
        "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1144&h=340&q=80",
      bannerAlt: "Banner Hunian Modern Colonial",
      logoImage: "https://placehold.co/120x120/png?text=Kota+Wisata",
      logoAlt: "Logo Kota Wisata",
      badgeText: "Sponsored",
      slotTier: "featured",
      url: "https://google.com",
    },
    {
      id: "adv-002",
      title: "Live Beyond Luxury",
      subtitle:
        "Tampilkan proyek properti premium Anda dengan visual yang meyakinkan dan placement yang lebih kuat.",
      bannerImage:
        "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1144&h=340&q=80",
      bannerAlt: "Banner Live Beyond Luxury",
      logoImage: "https://placehold.co/120x120/png?text=Metland",
      logoAlt: "Logo Metland",
      badgeText: "Sponsored",
      slotTier: "premium",
      url: "https://google.com",
    },
    {
      id: "adv-003",
      title: "Promo Hunian Terbaik",
      subtitle:
        "Cocok untuk promosi perumahan, apartemen, maupun proyek komersial yang ingin tampil lebih menonjol.",
      bannerImage:
        "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=1144&h=340&q=80",
      bannerAlt: "Banner Promo Hunian Terbaik",
      logoImage: "https://placehold.co/120x120/png?text=Developer",
      logoAlt: "Logo Developer",
      badgeText: "Sponsored",
      slotTier: "basic",
      url: "https://google.com",
    },
  ],
};

export const sponsoredBannerMockData = sponsoredBannerMockResponse.data;
export default sponsoredBannerMockResponse;